var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { attrs: { id: "logo" } }, [
      _vm.linked
        ? _c("a", { attrs: { href: "/" } }, [
            _c("span", { staticClass: "allied" }, [_vm._v("Allied")]),
            _c("span", { staticClass: "crowds" }, [_vm._v("Crowds")])
          ])
        : _c("div", { staticStyle: { "font-size": "25px" } }, [
            _c("span", { staticClass: "allied" }, [_vm._v("Allied")]),
            _c("span", { staticClass: "crowds" }, [_vm._v("Crowds")])
          ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-60f02b3a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-60f02b3a","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/elements/logo.vue
// module id = 82
// module chunks = 0